import React, {useState} from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import './FieldglassLearningJourney.css'

const FieldglassLearningJourney = () => {
    const [value, setValue] = useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
  return (
    <>
    <div className='learning-Journey-container'>
    <h2>SAP Fieldglass Learning Journey</h2>
    <div className='lj-menu-wrapper'>
        <Box sx={{ width: '100%', typography: 'body1' }} >
        <TabContext value={value}>
          <Box>
            <TabList onChange={handleChange} className="main-list" variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
              <Tab label="SAP Finance Consultant" value="1" className='list2 item'/>
            </TabList>
          </Box>
          <div className="lj-box">
          <TabPanel value="1">
            {/* <div className='lj-images'>
                <img src='images/SapFinance/SAP-FI-lj.png' alt='overall-img' className='lj-images' />
            </div> */}
            <div className='LJ-link-Wrapp'>
                  <img src='images/SapFieldglass/LearningJourney/LearningPath.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='SAP-Fieldglass'>
                    <p className='link1'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=WYVB-NBQO-I56V-4RSX-6BS4-2ULL-ZHJM-VMU2&linkId=ITEM_DETAILS&componentID=openSAP_23000&componentTypeID=E-Learning&fromSF=Y&revisionDate=1642052791000" target="_blank"><img src='images/SapFieldglass/LearningJourney/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://learning.sap.com/learning-journey/discovering-sap-fieldglass-contingent-workforce-management?userlogin=true&url_id=text-gl-lh" target="_blank"><img src='images/SapFieldglass/LearningJourney/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://learning.sap.com/learning-journey/discovering-sap-fieldglass-services-procurement?userlogin=true&url_id=text-gl-lh" target="_blank"><img src='images/SapFieldglass/LearningJourney/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=WYVB-NBQO-I56V-4RSX-6BS4-2ULL-ZHJM-VMU2&linkId=ITEM_DETAILS&componentID=FG200e_EN_Col2105&componentTypeID=E-Learning&fromSF=Y&revisionDate=1357992000000" target="_blank"><img src='images/SapFieldglass/LearningJourney/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=WYVB-NBQO-I56V-4RSX-6BS4-2ULL-ZHJM-VMU2&linkId=ITEM_DETAILS&componentID=FG310e_EN_Col2011&componentTypeID=E-Learning&fromSF=Y&revisionDate=1357992000000" target="_blank"><img src='images/SapFieldglass/LearningJourney/5.png'/></a>
                    </p>
                  </div>
                  </div>
                </div>
          </TabPanel>
          </div>
        </TabContext>
      </Box>
    </div>
    </div>
    </>
  )
}

export default FieldglassLearningJourney